import { ArraySerializer, Field, Type } from 'serialize-ts';
import { Attribute } from './attribute.model';
import { Promotion } from './promotion.model';
import { PriceRange } from '~app/modules/filters/models/price-range.model';
import { Category } from '~app/modules/generic/models';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { VolumePrice } from '~app/modules/filters/models/volume-price.model';
import { BlackDeal } from '~app/modules/filters/models/black-deal.model';

export class Filters {
  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Category)))
  categories: Category[];

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Category)))
  categoriesNext: Category[];

  @Field()
  promotion: Promotion;

  @Field()
  volumePrices: VolumePrice;

  @Field()
  priceRange: PriceRange;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Attribute)))
  attributes: Attribute[];

  @Field()
  blackFriday?: BlackDeal;
}
